<input
  [(ngModel)]="filterValue"
  (blur)="setSum()"
  type="text"
  class="filter-input"
  mask="separator.2"
  placeholder="{{'FILTERS.' + filter.fieldName | translate}}">
